import script from "./X1Button.vue?vue&type=script&lang=ts&setup=true"
export * from "./X1Button.vue?vue&type=script&lang=ts&setup=true"

import "./X1Button.vue?vue&type=style&index=0&id=748ab79e&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-748ab79e"]])

export default __exports__